import {deviceGroupScheduleConstants} from "../constants/device-group-schedule.constants";
import {deviceGroupScheduleService} from "../services/device-group-schedule.service";
import {modalActions} from "./modal.actions";
import {toastr} from 'react-redux-toastr'
import i18next from "i18next";

const getScheduleById = (deviceGroupId, forceReload = false) => {
    return dispatch => {
        deviceGroupScheduleService.getScheduleById(deviceGroupId)
            .then(
                (scheduleModel) => {
                    dispatch({type: deviceGroupScheduleConstants.SCHEDULE_BY_ID_SUCCESS, scheduleModel})
                },
                (error) => {
                    console.log(error)
                }
            );
    };
};

const editScheduleDay = (scheduleDayModal, errorHandler = function() {}) => {
    return dispatch => {
        deviceGroupScheduleService.editScheduleDay(scheduleDayModal)
            .then(
                () => {
                    dispatch(getScheduleById(scheduleDayModal.deviceGroupId));
                    dispatch(modalActions.hideModal());
                },
                (error) => {
                    console.log(error);
                    errorHandler(error.response);
                }
            );
    }
};

const createScheduleException = (scheduleExceptionModel, errorHandler = function() {}) => {
    return dispatch => {
        deviceGroupScheduleService.createScheduleException(scheduleExceptionModel)
            .then(
                () => {
                    dispatch(getScheduleById(scheduleExceptionModel.deviceGroupId));
                    dispatch(modalActions.hideModal());
                },
                (error) => {
                    console.log(error.response);
                    errorHandler(error.response);
                }
            )
    };
};

const editScheduleException = (scheduleExceptionModel, errorHandler = function() {}) => {
    return dispatch => {
        deviceGroupScheduleService.editScheduleException(scheduleExceptionModel)
            .then(
                () => {
                    dispatch(getScheduleById(scheduleExceptionModel.deviceGroupId));
                    dispatch(modalActions.hideModal());
                },
                (error) => {
                    console.log(error.response);
                    errorHandler(error.response);
                }
            )
    }
};

const deleteScheduleException = (scheduleExceptionModel) => {
    return dispatch => {
        deviceGroupScheduleService.deleteScheduleException(scheduleExceptionModel.id)
            .then(
                () => {
                    dispatch(getScheduleById(scheduleExceptionModel.deviceGroupId));
                    dispatch(modalActions.hideModal());
                    toastr.info(i18next.t('schedule'), i18next.t('msg.delete-schedule-exception', { id: scheduleExceptionModel.id }))
                },
                (error) => {
                    console.log(error)
                }
            )
    }
};

const clearStore = () => {
    return dispatch => {
        dispatch({type: deviceGroupScheduleConstants.SCHEDULE_BY_ID_CLEAR_STORE})
    }
};

export const deviceGroupScheduleAction = {
    getScheduleById,
    editScheduleDay,
    createScheduleException,
    editScheduleException,
    deleteScheduleException,
    clearStore
};
